export default class FilterSort {
  constructor(component) {
    this.dom = {
      $component: component,
      $sortToggle: document.querySelector('.js-sortToggle'),
      $filterContainer: document.querySelector('.js-filterContainer'),
    }
    this.state = {
      sortOpen: false,
      sortOpenClass: 'openSort',
    }
    this.sortToggleHandler = this.sortToggle.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom } = this
    dom.$sortToggle.addEventListener('click', this.sortToggleHandler)
  }

  sortToggle() {
    const { dom, state } = this

    if (state.sortOpen) {
      dom.$component.setAttribute('aria-hidden', 'true')
      dom.$component.setAttribute('aria-expanded', 'false')
      dom.$filterContainer.classList.remove(state.sortOpenClass)
      state.sortOpen = false
    } else {
      dom.$component.setAttribute('aria-hidden', 'false')
      dom.$component.setAttribute('aria-expanded', 'true')
      dom.$filterContainer.classList.add(state.sortOpenClass)
      state.sortOpen = true
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.FilterSort = this
  }
}
